<!--
 * Created by JackCui on 2021/12/1
 -->

<script>
  import {groupProps} from './index.js'

  export default {
    name: 'group',
    props: groupProps,
    model: {
      prop: 'isAction',
      event: 'change'
    },
    data () {
      return {
        action: this.isAction
      }
    },
    watch: {
      isAction (val) {
        if (!this.fold) {
          return
        }

        this.action = val
      }
    },
    methods: {
      change () {
        this.action = !this.action
        this.$emit('change', this.action)
      },
      setDefaultHeight (el) {
        el.style.height = el.scrollHeight + 'px'
      },
      enter (el) {
        if (el.scrollHeight !== 0) {
          el.style.height = el.scrollHeight + 'px'
        } else {
          el.style.height = ''
        }
      },
      leave (el) {
        if (el.scrollHeight !== 0) {
          el.style.height = 0
        }
      },
      afterEnter (el) {
        if (el.scrollHeight !== 0) {
          el.style.height = ''
        }
      },
      headerRender (h) {
        const {
          name,
          fold,
          action
        } = this
        return (
          <div class="group-header" style={this.action ? 'padding-bottom: 24px' : ''}>
            <div class="group-header-title font-color-primary">
              <div class='title'>
                {
                  this.$scopedSlots.header || this.$slots.header || name
                }
              </div>
              <div class="after-title">
                {
                  this.$scopedSlots.afterTitle || this.$slots.afterTitle
                }
              </div>
            </div>
            <div class="group-header-operate">
              {
                this.$scopedSlots.headerOperate || this.$slots.headerOperate
              }
              {
                fold &&
                (<div
                  class={[
                    'operate-item',
                    {'rotate90': action}
                  ]}
                  onClick={this.change}
                >
                  <i class="el-icon-arrow-down"/>
                </div>)
              }
            </div>
          </div>
        )
      },
      bodyRender (h) {
        const defaultSlot = this.$scopedSlots.default || this.$slots.default
        return (
          defaultSlot &&
          (
            <div class="group-body">
              {
                defaultSlot
              }
            </div>
          )
        )
      }
    },
    render (h) {
      const {
        shadow,
        borderStyle,
        hideHeader,
        action
      } = this
      return (
        <div
          class={[
            'mod-group-wrap',
            {
              'border-shadow': shadow,
              'hide-header': hideHeader
            }
          ]}
          style={borderStyle}
        >
          {
            hideHeader
              ? null
              : this.headerRender(h)
          }
          <transition
            v-on:before-enter={this.setDefaultHeight}
            v-on:before-leave={this.setDefaultHeight}
            v-on:enter={this.enter}
            v-on:leave={this.leave}
            v-on:after-enter={this.afterEnter}
          >
            <div class="transition-wrap" v-show={action}>
              {
                this.bodyRender(h)
              }
            </div>
          </transition>
        </div>
      )
    }
  }
</script>

<style lang="scss" scoped>
  .border-shadow {
    box-shadow: 0 0 8px rgba(57, 121, 201, 0.14);
  }

  .mod-group-wrap {
    padding: 16px 24px;
    border: 1px solid #D6DFFF;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 8px;

    .transition-wrap {
      transition: .3s height;
    }
    .v-enter-active {
      overflow: hidden;
    }
    .v-leave-active {
      overflow: hidden;
    }
    .group-body {
      padding: 0;
    }

    .group-header {
      position: relative;
      // padding-bottom: 24px;
      transition: padding .3s;

      .group-header-operate {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;

        & > * {
          margin-left: 8px;
          display: inline-block;
        }

        .operate-item {
          transition: all .3s;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;

          i {
            display: inline-block;
            font-size: 16px;
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }
        }

        .rotate90 {
          transform: rotate(180deg);
        }
      }

      .group-header-title {
        padding-left: 12px;
        position: relative;

        & > * {
          margin-right: 16px;
          display: inline-block;
          vertical-align: middle;
        }

        .title {
          height: 24px;
          font-weight: 500;
          font-size: 18px;
          line-height: 24px;
          color: #242F57;
        }

        &::before {
          content: "";
          width: 4px;
          display: inline-block;
          background: currentColor;
          position: absolute;
          left: 0;
          top: 4px;
          bottom: 4px;
        }
      }
    }
  }

  .hide-header {
    padding: 0 24px;

    .group-body {
      padding: 16px 0;
    }
  }
</style>
